<template>
  <el-dialog v-dialog-drag :title="title" :width="width" :visible="visible" :close-on-click-modal="false" @close="visible = false">
    <el-form id="item" label-width="120px" label-position="right" label-suffix="：" :inline="false" @submit.native.prevent>
      <el-form-item label="映射主客户" width="180px">
        {{ bindInfo.main.Name }} <font v-if="selectPurchaserID == bindInfo.main.PurchaserID" style="color: #409eff"> 当前账号</font>
      </el-form-item>
    </el-form>
    <el-table
      ref="detailTable"
      :data="bindInfo.childs"
      v-loading="loading"
      border
      height="100%"
      min-height="300px"
      style="height: 300px !important"
    >
      <el-table-column prop="Name" label="子客户名称" align="center" min-width="160">
        <template slot-scope="{ row }">
          {{ row.Name }}{{ row.QQ ? '(' + row.QQ + ')' : '' }}
          <div v-if="selectPurchaserID == row.PurchaserID" style="color: #409eff"> 当前账号</div>
        </template>
      </el-table-column>
      <el-table-column prop="BindTime" label="映射时间" align="center" min-width="160" />
      <el-table-column prop="BindPermissions" label="映射权限" align="center" min-width="120">
        <template slot-scope="{ row }">
          {{ row.BindPermissions == 2 ? '映射客户价格' : '映射客户接单' }}
        </template>
      </el-table-column>
      <el-table-column prop="OP" label="操作" align="center" min-width="55">
        <template slot-scope="{ row }">
          <el-link type="primary" plain size="mini" @click="unBind(row)">解绑</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer"> </div>
  </el-dialog>
</template>
<script>
import { submit } from '@/api/base'
export default {
  name: 'BindUserList',
  components: {},
  data() {
    return {
      loading: false,
      visible: false,
      width: '650px',
      title: '客户关系映射',
      bindInfo: {
        main: {},
        childs: [],
      },
      selectPurchaserID: '',
    }
  },
  methods: {
    async show(row) {
      this.visible = true
      this.selectPurchaserID = row.PurchaserID
      this.loading = true
      await this.getBindInfo(row.PurchaserID)
    },
    async getBindInfo(purchaserID) {
      const { data } = await submit('/api/stall/getPurchaserChildsByChild', {
        purchaserID: purchaserID,
      })
      this.loading = false
      this.bindInfo = data
    },
    async unBind(row) {
      let senderParam = { PurchaserID: row.PurchaserID, ParentPurchaserID: row.ParentPurchaserID }
      this.$confirm(`已提交数据不可恢复，确定解绑映射吗？`, '解绑映射', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await submit('/api/stall/unBindPurchaser', senderParam)
        this.$message({
          type: 'success',
          message: '解绑成功!',
        })
        this.handleClose()
      })
    },
    handleClose() {
      this.visible = false
      this.$emit('handleQuery')
    },
  },
}
</script>

<style lang="scss" scoped>
.amount-type {
  ::v-deep {
    .el-select {
      width: 105px !important;

      &:not(:last-child) {
        margin-right: 2px;
      }
    }
  }
}
</style>
